"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchUsageSummaryQuery = exports.usageApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.usageApi = (0, react_1.createApi)({
    reducerPath: "usageApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["usage"],
    endpoints: function (builder) { return ({
        fetchUsageSummary: builder.query({
            query: function (obj) { return ({
                url: "/v1/usage/summary",
                method: "GET",
                params: {
                    clientId: obj.clientId,
                    buildingId: obj.buildingId,
                    billingPeriod: obj.billingPeriod,
                },
            }); },
            providesTags: ["usage"],
        }),
    }); },
});
exports.useFetchUsageSummaryQuery = exports.usageApi.useFetchUsageSummaryQuery;
